@if(show) {
<div class="fixed top-6 right-6 z-[9999]">
  <app-alert [title]="toastTitle" [message]="toastMessage" [type]="toastType" [duration]="4000" role="alert"
      aria-live="assertive">
  </app-alert>
</div>
}

<div class="auth-desktop-layout min-h-screen bg-white">
    <div class="relative hidden w-1/2 overflow-hidden bg-[#0F0F3D] md:flex">
        <img src="assets/images/fondo-main.svg" alt="" class="absolute inset-0 h-full w-full object-cover" />
        <img src="assets/images/fondo 1.svg" alt="" class="absolute inset-0 h-full w-full object-cover mix-blend-screen opacity-100" />

        <div class="relative z-10 flex h-full w-full flex-col justify-between px-6 py-8 lg:pl-20 lg:pr-12 lg:py-12">
            <div>
                <img src="assets/images/ardia.svg" alt="ARDIA" class="h-7 cursor-pointer brightness-0 invert lg:h-10" routerLink="/" />
            </div>

            <div class="flex flex-1 items-center">
                <h1 class="text-3xl font-extrabold leading-[1.15] tracking-tight text-white md:text-4xl lg:text-[3.2rem] xl:text-[3.5rem]" style="text-shadow: 0 1px 8px rgba(0,0,0,0.18);">
                    La plataforma de<br>
                    <span class="text-[#60A5FA]">Agentes<br>Inteligentes</span>,<br>
                    conectada a los<br>
                    datos de tu<br>
                    empresa en<br>
                    tiempo real.
                </h1>
            </div>

            <div class="flex w-full items-center gap-4">
                <div class="h-px flex-1 bg-white/30"></div>
                <p class="whitespace-nowrap text-[11px] font-semibold uppercase tracking-[0.3em] text-white/80">Inteligencia artificial para empresas</p>
                <div class="h-px flex-1 bg-white/30"></div>
            </div>
        </div>
    </div>

    @if(currentStep === 'form') {
    <div class="flex w-full items-center justify-center px-6 py-10 md:w-1/2">
        <div class="w-full max-w-[540px]">

            <div class="mb-10 flex items-center gap-8">
                <a routerLink="/"
                    class="cursor-pointer border-b-2 border-transparent pb-2.5 text-[15px] font-medium text-[#9CA3AF] no-underline transition-colors hover:text-[#6B7280]">
                    Iniciar Sesión
                </a>
                <span class="border-b-2 border-[var(--color-brand-400)] pb-2.5 text-[15px] font-semibold text-[var(--color-brand-400)]">
                    Crear Cuenta
                </span>
            </div>

            <h2 class="mb-1.5 text-[28px] font-bold text-[#111827]">Crear cuenta profesional</h2>
            <p class="mb-8 text-[15px] text-[#6B7280]">Regístrate para acceder a tus agentes conectados.</p>

            <form [formGroup]="registerForm" (ngSubmit)="register()" class="flex flex-col gap-4"
                aria-labelledby="register-form-heading">
                <h3 id="register-form-heading" class="sr-only">Formulario de registro</h3>
                <input type="hidden" formControlName="profileType" value="empresa">

                <div class="flex flex-col gap-3 sm:flex-row">
                    <div class="w-full sm:w-1/2">
                        <label for="name" class="mb-1.5 block text-[11px] font-semibold uppercase tracking-wider text-[#6B7280]">Nombre *</label>
                        <input id="name" type="text" formControlName="name" required placeholder="Tu nombre"
                            class="w-full rounded-lg border border-[#E5E7EB] bg-[#F9FAFB] px-4 py-3 text-[14px] text-[#111827] placeholder-[#9CA3AF] transition-colors focus:border-[var(--color-brand-400)] focus:outline-none focus:ring-1 focus:ring-[var(--color-brand-400)]/30" />
                        <div class="mt-1 text-[10px] text-[var(--color-error-500)] sm:text-xs" aria-live="polite">
                            @if(registerForm.get('name')?.invalid && registerForm.get('name')?.touched) { Introduce un nombre válido }
                        </div>
                    </div>
                    <div class="w-full sm:w-1/2">
                        <label for="lastName" class="mb-1.5 block text-[11px] font-semibold uppercase tracking-wider text-[#6B7280]">Apellidos</label>
                        <input id="lastName" type="text" formControlName="lastName" placeholder="Tus apellidos"
                            class="w-full rounded-lg border border-[#E5E7EB] bg-[#F9FAFB] px-4 py-3 text-[14px] text-[#111827] placeholder-[#9CA3AF] transition-colors focus:border-[var(--color-brand-400)] focus:outline-none focus:ring-1 focus:ring-[var(--color-brand-400)]/30" />
                    </div>
                </div>

                <div class="flex flex-col gap-3 sm:flex-row">
                    <div class="w-full sm:w-1/2">
                        <label for="email" class="mb-1.5 block text-[11px] font-semibold uppercase tracking-wider text-[#6B7280]">Email Profesional *</label>
                        <input id="email" type="email" formControlName="email" required placeholder="nombre@empresa.com"
                            autocomplete="email" (input)="convertToLowercase($event, 'email')" style="text-transform: lowercase;"
                            class="w-full rounded-lg border border-[#E5E7EB] bg-[#F9FAFB] px-4 py-3 text-[14px] text-[#111827] placeholder-[#9CA3AF] transition-colors focus:border-[var(--color-brand-400)] focus:outline-none focus:ring-1 focus:ring-[var(--color-brand-400)]/30" />
                        <div class="mt-1 text-[10px] text-[var(--color-error-500)] sm:text-xs" aria-live="polite">
                            @if(registerForm.get('email')?.invalid && registerForm.get('email')?.touched) { Introduce un correo electrónico válido }
                        </div>
                    </div>
                    <div class="w-full sm:w-1/2">
                        <label for="phone" class="mb-1.5 block text-[11px] font-semibold uppercase tracking-wider text-[#6B7280]">Teléfono *</label>
                        <div class="relative">
                            <span class="absolute left-3.5 top-1/2 -translate-y-1/2 text-[#9CA3AF]">
                                <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M2.25 6.75c0 8.284 6.716 15 15 15h2.25a2.25 2.25 0 002.25-2.25v-1.372c0-.516-.351-.966-.852-1.091l-4.423-1.106c-.44-.11-.902.055-1.173.417l-.97 1.293c-.282.376-.769.542-1.21.38a12.035 12.035 0 01-7.143-7.143c-.162-.441.004-.928.38-1.21l1.293-.97c.363-.271.527-.734.417-1.173L6.963 3.102a1.125 1.125 0 00-1.091-.852H4.5A2.25 2.25 0 002.25 4.5v2.25z" /></svg>
                            </span>
                            <input id="phone" type="tel" formControlName="phone" required placeholder="+34 600 000 000"
                                class="w-full rounded-lg border border-[#E5E7EB] bg-[#F9FAFB] pl-10 pr-4 py-3 text-[14px] text-[#111827] placeholder-[#9CA3AF] transition-colors focus:border-[var(--color-brand-400)] focus:outline-none focus:ring-1 focus:ring-[var(--color-brand-400)]/30" />
                        </div>
                        <div class="mt-1 text-[10px] text-[var(--color-error-500)] sm:text-xs" aria-live="polite">
                            @if(registerForm.get('phone')?.invalid && registerForm.get('phone')?.touched) { El formato del teléfono no es válido }
                        </div>
                    </div>
                </div>

                <div class="flex flex-col gap-3 sm:flex-row">
                    <div class="w-full sm:w-1/2">
                        <label for="companyName" class="mb-1.5 block text-[11px] font-semibold uppercase tracking-wider text-[#6B7280]">Empresa *</label>
                        <input id="companyName" type="text" formControlName="companyName" required placeholder="Nombre de la empresa"
                            class="w-full rounded-lg border border-[#E5E7EB] bg-[#F9FAFB] px-4 py-3 text-[14px] text-[#111827] placeholder-[#9CA3AF] transition-colors focus:border-[var(--color-brand-400)] focus:outline-none focus:ring-1 focus:ring-[var(--color-brand-400)]/30" />
                        <div class="mt-1 text-[10px] text-[var(--color-error-500)] sm:text-xs" aria-live="polite">
                            @if(registerForm.get('companyName')?.invalid && registerForm.get('companyName')?.touched) { Introduce un nombre de empresa válido }
                        </div>
                    </div>
                    <div class="w-full sm:w-1/2">
                        <label for="nif" class="mb-1.5 block text-[11px] font-semibold uppercase tracking-wider text-[#6B7280]">NIF *</label>
                        <input id="nif" type="text" formControlName="nif" required placeholder="B12345678"
                            class="w-full rounded-lg border border-[#E5E7EB] bg-[#F9FAFB] px-4 py-3 text-[14px] text-[#111827] placeholder-[#9CA3AF] transition-colors focus:border-[var(--color-brand-400)] focus:outline-none focus:ring-1 focus:ring-[var(--color-brand-400)]/30" />
                        <div class="mt-1 text-[10px] text-[var(--color-error-500)] sm:text-xs" aria-live="polite">
                            @if(registerForm.get('nif')?.invalid && registerForm.get('nif')?.touched) { Introduce un NIF válido }
                        </div>
                    </div>
                </div>

                <div class="flex flex-col gap-3 sm:flex-row">
                    <div class="w-full sm:w-1/2">
                        <label for="password" class="mb-1.5 block text-[11px] font-semibold uppercase tracking-wider text-[#6B7280]">Contraseña *</label>
                        <div class="relative">
                            <input id="password" [type]="showPassword ? 'text' : 'password'" formControlName="password" required placeholder="Contraseña segura"
                                class="w-full rounded-lg border border-[#E5E7EB] bg-[#F9FAFB] px-4 py-3 pr-12 text-[14px] text-[#111827] placeholder-[#9CA3AF] transition-colors focus:border-[var(--color-brand-400)] focus:outline-none focus:ring-1 focus:ring-[var(--color-brand-400)]/30" />
                            <button type="button" tabindex="-1" (click)="togglePasswordVisibility()"
                                class="absolute right-3 top-1/2 -translate-y-1/2 cursor-pointer text-[#9CA3AF] transition-colors hover:text-[#6B7280] focus:outline-none"
                                aria-label="Mostrar/ocultar contraseña">
                                @if(showPassword) {
                                    <fa-icon [icon]="faEyeSlash" class="text-sm"></fa-icon>
                                } @else {
                                    <fa-icon [icon]="faEye" class="text-sm"></fa-icon>
                                }
                            </button>
                        </div>
                    </div>
                    <div class="w-full sm:w-1/2">
                        <label for="passwordConfirmation" class="mb-1.5 block text-[11px] font-semibold uppercase tracking-wider text-[#6B7280]">Confirmar Contraseña *</label>
                        <div class="relative">
                            <input id="passwordConfirmation" [type]="showPasswordConfirm ? 'text' : 'password'" formControlName="passwordConfirmation" required placeholder="Repite la contraseña"
                                class="w-full rounded-lg border border-[#E5E7EB] bg-[#F9FAFB] px-4 py-3 pr-12 text-[14px] text-[#111827] placeholder-[#9CA3AF] transition-colors focus:border-[var(--color-brand-400)] focus:outline-none focus:ring-1 focus:ring-[var(--color-brand-400)]/30" />
                            <button type="button" tabindex="-1" (click)="togglePasswordConfirmVisibility()"
                                class="absolute right-3 top-1/2 -translate-y-1/2 cursor-pointer text-[#9CA3AF] transition-colors hover:text-[#6B7280] focus:outline-none"
                                aria-label="Mostrar/ocultar contraseña">
                                @if(showPasswordConfirm) {
                                    <fa-icon [icon]="faEyeSlash" class="text-sm"></fa-icon>
                                } @else {
                                    <fa-icon [icon]="faEye" class="text-sm"></fa-icon>
                                }
                            </button>
                        </div>
                        <div class="mt-1 text-[10px] text-[var(--color-error-500)] sm:text-xs" aria-live="polite">
                            @if(registerForm.get('passwordConfirmation')?.invalid && registerForm.get('passwordConfirmation')?.touched) {
                                @if(registerForm.get('passwordConfirmation')?.errors?.['required']) { Debes confirmar tu contraseña }
                                @else if(registerForm.get('passwordConfirmation')?.errors?.['passwordMismatch']) { Las contraseñas no coinciden }
                            }
                        </div>
                    </div>
                </div>

                @if (registerForm.get('password')?.value) {
                <div class="mt-1 space-y-2" aria-live="polite">
                    <p class="text-xs font-medium text-[#6B7280]">Requisitos:</p>
                    <div class="flex items-center gap-2">
                        <span class="w-4 h-4 rounded-full shrink-0 flex items-center justify-center"
                            [class.bg-green-500]="getPasswordRequirements().minLength"
                            [class.bg-red-200]="!getPasswordRequirements().minLength">
                            @if (getPasswordRequirements().minLength) { <span class="text-white text-[10px] leading-none">✓</span> }
                        </span>
                        <span class="text-xs" [class.text-green-600]="getPasswordRequirements().minLength" [class.text-gray-400]="!getPasswordRequirements().minLength">Mínimo 8 caracteres</span>
                    </div>
                    <div class="flex items-center gap-2">
                        <span class="w-4 h-4 rounded-full shrink-0 flex items-center justify-center"
                            [class.bg-green-500]="getPasswordRequirements().hasUppercase"
                            [class.bg-red-200]="!getPasswordRequirements().hasUppercase">
                            @if (getPasswordRequirements().hasUppercase) { <span class="text-white text-[10px] leading-none">✓</span> }
                        </span>
                        <span class="text-xs" [class.text-green-600]="getPasswordRequirements().hasUppercase" [class.text-gray-400]="!getPasswordRequirements().hasUppercase">Una mayúscula (A-Z)</span>
                    </div>
                    <div class="flex items-center gap-2">
                        <span class="w-4 h-4 rounded-full shrink-0 flex items-center justify-center"
                            [class.bg-green-500]="getPasswordRequirements().hasLowercase"
                            [class.bg-red-200]="!getPasswordRequirements().hasLowercase">
                            @if (getPasswordRequirements().hasLowercase) { <span class="text-white text-[10px] leading-none">✓</span> }
                        </span>
                        <span class="text-xs" [class.text-green-600]="getPasswordRequirements().hasLowercase" [class.text-gray-400]="!getPasswordRequirements().hasLowercase">Una minúscula (a-z)</span>
                    </div>
                    <div class="flex items-center gap-2">
                        <span class="w-4 h-4 rounded-full shrink-0 flex items-center justify-center"
                            [class.bg-green-500]="getPasswordRequirements().hasNumber"
                            [class.bg-red-200]="!getPasswordRequirements().hasNumber">
                            @if (getPasswordRequirements().hasNumber) { <span class="text-white text-[10px] leading-none">✓</span> }
                        </span>
                        <span class="text-xs" [class.text-green-600]="getPasswordRequirements().hasNumber" [class.text-gray-400]="!getPasswordRequirements().hasNumber">Un número (0-9)</span>
                    </div>
                    <div class="flex items-center gap-2">
                        <span class="w-4 h-4 rounded-full shrink-0 flex items-center justify-center"
                            [class.bg-green-500]="getPasswordRequirements().hasSpecial"
                            [class.bg-red-200]="!getPasswordRequirements().hasSpecial">
                            @if (getPasswordRequirements().hasSpecial) { <span class="text-white text-[10px] leading-none">✓</span> }
                        </span>
                        <span class="text-xs" [class.text-green-600]="getPasswordRequirements().hasSpecial" [class.text-gray-400]="!getPasswordRequirements().hasSpecial">Un carácter especial (!&#64;#$%etc)</span>
                    </div>
                </div>
                }

                <div class="mt-1">
                    <div class="flex items-start gap-2.5">
                        <input type="checkbox" formControlName="acceptTerms" id="acceptTerms"
                            class="mt-0.5 h-4 w-4 cursor-pointer rounded border-[#D1D5DB] text-[var(--color-brand-400)] focus:ring-[var(--color-brand-400)]/30" />
                        <span class="text-[13px] leading-snug text-[#6B7280]">
                            <label for="acceptTerms" class="cursor-pointer">Acepto las </label><a (click)="openLegalModal($event, 'Condiciones de servicio')" class="cursor-pointer font-semibold text-[var(--color-brand-400)] hover:underline">Condiciones de servicio</a><label for="acceptTerms" class="cursor-pointer"> y la </label><a (click)="openLegalModal($event, 'Política de privacidad')" class="cursor-pointer font-semibold text-[var(--color-brand-400)] hover:underline">Política de privacidad</a><label for="acceptTerms" class="cursor-pointer">.</label>
                        </span>
                    </div>
                    <div class="mt-1 text-[10px] text-[var(--color-error-500)] sm:text-xs" aria-live="polite">
                        @if(registerForm.get('acceptTerms')?.invalid && registerForm.get('acceptTerms')?.touched) { Debes aceptar las condiciones para continuar }
                    </div>
                </div>

                <div class="h-px w-full bg-[#E5E7EB]/40"></div>

                <button type="submit"
                    class="mt-2 flex h-[50px] w-full cursor-pointer items-center justify-center gap-2 rounded-xl bg-[var(--color-brand-400)] text-[15px] font-semibold text-white shadow-sm transition-colors hover:bg-[var(--color-brand-500)] disabled:cursor-not-allowed disabled:bg-[#D1D5DB]"
                    [disabled]="isLoading" aria-label="Registrarse">
                    @if(isLoading) {
                        <div class="h-4 w-4 animate-spin rounded-full border-2 border-white border-t-transparent"></div>
                        <span>Registrando...</span>
                    } @else {
                        <span>Continuar</span>
                        <fa-icon [icon]="faChevronRight" class="text-xs"></fa-icon>
                    }
                </button>
            </form>

            <div class="mt-6">
                <a routerLink="/" class="flex items-center text-[14px] font-semibold text-[var(--color-brand-400)] no-underline hover:underline"
                    aria-label="Iniciar sesión">
                    Ya tengo cuenta
                    <fa-icon [icon]="faChevronRight" class="ml-1 text-sm"></fa-icon>
                </a>
            </div>
        </div>
    </div>
    }
</div>

<div class="auth-page auth-mobile-layout">
  <section class="auth-shell auth-shell--wide">
    <div class="auth-hero">
      <a routerLink="/" class="auth-logo-link" aria-label="Volver al inicio">
        <img src="assets/images/ardia.svg" alt="ARDIA" class="auth-logo" />
      </a>

      <div class="auth-hero-copy">
        <h1 class="auth-hero-title">
          La plataforma de
          <span>Agentes Inteligentes,</span>
          conectada a tus datos
        </h1>
        <p class="auth-hero-tagline">Inteligencia artificial para empresas</p>
      </div>
    </div>

    @if(currentStep === 'form') {
    <div class="auth-panel">
      <div class="auth-tabs" role="tablist" aria-label="Acceso">
        <a routerLink="/" class="auth-tab" role="tab" aria-selected="false">Iniciar sesión</a>
        <span class="auth-tab is-active" role="tab" aria-selected="true">Crear cuenta</span>
      </div>

      <div class="auth-heading">
        <h2 class="auth-title">Crear cuenta profesional</h2>
        <p class="auth-subtitle">Gestiona tu negocio de forma inteligente en un solo lugar.</p>
      </div>

      <form
        [formGroup]="registerForm"
        (ngSubmit)="register()"
        class="auth-form"
        aria-labelledby="register-form-heading-mobile"
      >
        <h3 id="register-form-heading-mobile" class="sr-only">Formulario de registro</h3>
        <input type="hidden" formControlName="profileType" value="empresa" />

        <div class="auth-grid-two auth-grid-two--mobile-register">
          <div class="auth-field">
            <label for="name-mobile" class="auth-label">Nombre*</label>
            <input id="name-mobile" type="text" formControlName="name" required placeholder="Tu nombre" class="auth-input" />
            <div class="auth-error" aria-live="polite">
              @if(registerForm.get('name')?.invalid && registerForm.get('name')?.touched) { Introduce un nombre válido }
            </div>
          </div>

          <div class="auth-field">
            <label for="lastName-mobile" class="auth-label">Apellidos*</label>
            <input id="lastName-mobile" type="text" formControlName="lastName" placeholder="Tus apellidos" class="auth-input" />
          </div>

          <div class="auth-field">
            <label for="email-mobile" class="auth-label">Email profesional*</label>
            <input
              id="email-mobile"
              type="email"
              formControlName="email"
              required
              placeholder="ejemplo@empresa.com"
              autocomplete="email"
              (input)="convertToLowercase($event, 'email')"
              style="text-transform: lowercase;"
              class="auth-input"
            />
            <div class="auth-error" aria-live="polite">
              @if(registerForm.get('email')?.invalid && registerForm.get('email')?.touched) { Introduce un correo electrónico válido }
            </div>
          </div>

          <div class="auth-field">
            <label for="phone-mobile" class="auth-label">Teléfono*</label>
            <div class="auth-input-wrap">
              <span class="auth-field-icon" aria-hidden="true">
                <svg class="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M2.25 6.75c0 8.284 6.716 15 15 15h2.25a2.25 2.25 0 002.25-2.25v-1.372c0-.516-.351-.966-.852-1.091l-4.423-1.106c-.44-.11-.902.055-1.173.417l-.97 1.293c-.282.376-.769.542-1.21.38a12.035 12.035 0 01-7.143-7.143c-.162-.441.004-.928.38-1.21l1.293-.97c.363-.271.527-.734.417-1.173L6.963 3.102a1.125 1.125 0 00-1.091-.852H4.5A2.25 2.25 0 002.25 4.5v2.25z" />
                </svg>
              </span>
              <input id="phone-mobile" type="tel" formControlName="phone" required placeholder="+34 600 000 000" class="auth-input auth-input--with-icon" />
            </div>
            <div class="auth-error" aria-live="polite">
              @if(registerForm.get('phone')?.invalid && registerForm.get('phone')?.touched) { El formato del teléfono no es válido }
            </div>
          </div>

          <div class="auth-field">
            <label for="companyName-mobile" class="auth-label">Empresa*</label>
            <input id="companyName-mobile" type="text" formControlName="companyName" required placeholder="Nombre fiscal" class="auth-input" />
            <div class="auth-error" aria-live="polite">
              @if(registerForm.get('companyName')?.invalid && registerForm.get('companyName')?.touched) { Introduce un nombre de empresa válido }
            </div>
          </div>

          <div class="auth-field">
            <label for="nif-mobile" class="auth-label">NIF</label>
            <input id="nif-mobile" type="text" formControlName="nif" required placeholder="A00000000" class="auth-input" />
            <div class="auth-error" aria-live="polite">
              @if(registerForm.get('nif')?.invalid && registerForm.get('nif')?.touched) { Introduce un NIF válido }
            </div>
          </div>

          <div class="auth-field">
            <label for="password-mobile" class="auth-label">Contraseña*</label>
            <div class="auth-input-wrap">
              <input
                id="password-mobile"
                [type]="showPassword ? 'text' : 'password'"
                formControlName="password"
                required
                placeholder="••••••••"
                class="auth-input auth-input--with-action"
              />
              <button
                type="button"
                tabindex="-1"
                (click)="togglePasswordVisibility()"
                class="auth-input-action"
                aria-label="Mostrar u ocultar contraseña"
              >
                @if(showPassword) {
                <fa-icon [icon]="faEyeSlash"></fa-icon>
                } @else {
                <fa-icon [icon]="faEye"></fa-icon>
                }
              </button>
            </div>
          </div>

          <div class="auth-field">
            <label for="passwordConfirmation-mobile" class="auth-label">Confirmar contraseña*</label>
            <div class="auth-input-wrap">
              <input
                id="passwordConfirmation-mobile"
                [type]="showPasswordConfirm ? 'text' : 'password'"
                formControlName="passwordConfirmation"
                required
                placeholder="••••••••"
                class="auth-input auth-input--with-action"
              />
              <button
                type="button"
                tabindex="-1"
                (click)="togglePasswordConfirmVisibility()"
                class="auth-input-action"
                aria-label="Mostrar u ocultar contraseña"
              >
                @if(showPasswordConfirm) {
                <fa-icon [icon]="faEyeSlash"></fa-icon>
                } @else {
                <fa-icon [icon]="faEye"></fa-icon>
                }
              </button>
            </div>
            <div class="auth-error" aria-live="polite">
              @if(registerForm.get('passwordConfirmation')?.invalid && registerForm.get('passwordConfirmation')?.touched) {
                @if(registerForm.get('passwordConfirmation')?.errors?.['required']) { Debes confirmar tu contraseña }
                @else if(registerForm.get('passwordConfirmation')?.errors?.['passwordMismatch']) { Las contraseñas no coinciden }
              }
            </div>
          </div>
        </div>

        @if (registerForm.get('password')?.value) {
        <div class="space-y-2" aria-live="polite">
          <p class="text-xs font-medium text-[#6B7280]">Requisitos de contraseña:</p>
          <div class="flex items-center gap-2">
            <span class="w-4 h-4 rounded-full shrink-0 flex items-center justify-center"
                [class.bg-green-500]="getPasswordRequirements().minLength"
                [class.bg-red-200]="!getPasswordRequirements().minLength">
              @if (getPasswordRequirements().minLength) { <span class="text-white text-[10px] leading-none">✓</span> }
            </span>
            <span class="text-xs" [class.text-green-600]="getPasswordRequirements().minLength" [class.text-gray-400]="!getPasswordRequirements().minLength">Mínimo 8 caracteres</span>
          </div>
          <div class="flex items-center gap-2">
            <span class="w-4 h-4 rounded-full shrink-0 flex items-center justify-center"
                [class.bg-green-500]="getPasswordRequirements().hasUppercase"
                [class.bg-red-200]="!getPasswordRequirements().hasUppercase">
              @if (getPasswordRequirements().hasUppercase) { <span class="text-white text-[10px] leading-none">✓</span> }
            </span>
            <span class="text-xs" [class.text-green-600]="getPasswordRequirements().hasUppercase" [class.text-gray-400]="!getPasswordRequirements().hasUppercase">Una mayúscula (A-Z)</span>
          </div>
          <div class="flex items-center gap-2">
            <span class="w-4 h-4 rounded-full shrink-0 flex items-center justify-center"
                [class.bg-green-500]="getPasswordRequirements().hasLowercase"
                [class.bg-red-200]="!getPasswordRequirements().hasLowercase">
              @if (getPasswordRequirements().hasLowercase) { <span class="text-white text-[10px] leading-none">✓</span> }
            </span>
            <span class="text-xs" [class.text-green-600]="getPasswordRequirements().hasLowercase" [class.text-gray-400]="!getPasswordRequirements().hasLowercase">Una minúscula (a-z)</span>
          </div>
          <div class="flex items-center gap-2">
            <span class="w-4 h-4 rounded-full shrink-0 flex items-center justify-center"
                [class.bg-green-500]="getPasswordRequirements().hasNumber"
                [class.bg-red-200]="!getPasswordRequirements().hasNumber">
              @if (getPasswordRequirements().hasNumber) { <span class="text-white text-[10px] leading-none">✓</span> }
            </span>
            <span class="text-xs" [class.text-green-600]="getPasswordRequirements().hasNumber" [class.text-gray-400]="!getPasswordRequirements().hasNumber">Un número (0-9)</span>
          </div>
          <div class="flex items-center gap-2">
            <span class="w-4 h-4 rounded-full shrink-0 flex items-center justify-center"
                [class.bg-green-500]="getPasswordRequirements().hasSpecial"
                [class.bg-red-200]="!getPasswordRequirements().hasSpecial">
              @if (getPasswordRequirements().hasSpecial) { <span class="text-white text-[10px] leading-none">✓</span> }
            </span>
            <span class="text-xs" [class.text-green-600]="getPasswordRequirements().hasSpecial" [class.text-gray-400]="!getPasswordRequirements().hasSpecial">Un carácter especial (!&#64;#$%etc)</span>
          </div>
        </div>
        }

        <div class="auth-legal-row">
          <label class="auth-checkbox auth-checkbox--top" for="acceptTermsMobile">
            <input type="checkbox" formControlName="acceptTerms" id="acceptTermsMobile" />
            <span>
              Acepto las
              <a (click)="openLegalModal($event, 'Condiciones de servicio')" class="auth-inline-link">Condiciones de servicio</a>
              y la
              <a (click)="openLegalModal($event, 'Política de privacidad')" class="auth-inline-link">Política de privacidad</a>.
            </span>
          </label>
          <div class="auth-error" aria-live="polite">
            @if(registerForm.get('acceptTerms')?.invalid && registerForm.get('acceptTerms')?.touched) { Debes aceptar las condiciones para continuar }
          </div>
        </div>

        <button
          type="submit"
          class="auth-primary-button"
          [disabled]="isLoading"
          aria-label="Registrarse"
        >
          @if(isLoading) {
          <div class="auth-button-spinner"></div>
          <span>Registrando...</span>
          } @else {
          <span>Continuar</span>
          <fa-icon [icon]="faChevronRight"></fa-icon>
          }
        </button>
      </form>

      <p class="auth-copyright">© ARDIA. Todos los derechos reservados.</p>
    </div>
    }
  </section>
</div>

@if (showLegalModal) {
<app-legal-modal [title]="legalModalTitle" (close)="showLegalModal = false"></app-legal-modal>
}
